import { render } from "./BookingComponent.vue?vue&type=template&id=5223cdc5&scoped=true"
import script from "./BookingComponent.vue?vue&type=script&lang=js"
export * from "./BookingComponent.vue?vue&type=script&lang=js"

import "./BookingComponent.vue?vue&type=style&index=0&id=5223cdc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5223cdc5"]])

export default __exports__